import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import TopTradedTokens from "../components/TopTradedTokens";
import MarketInsightsPanel from "../components/MarketInsights";
import HeroSection from "../components/HeroSection";

const Home = () => {
    return (
        <>
            <Navbar />
            <HeroSection />
            <main>
                <div id="market-insights-panel" className="bg-gradient-to-br from-black via-gray-900 to-black text-white">
                    <MarketInsightsPanel />
                </div>
                <div id="top-traded">
                    <TopTradedTokens />
                </div>
            </main>
            <Footer />
        </>
    );
};

export default Home;
